class AnyDecoder {
    decode(data) {
        return data.value;
    }
}
export default new AnyDecoder();
//# sourceMappingURL=AnyDecoder.js.map